import React from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Text } from "../../components/user/Text";
import { Image } from "../../components/user/Image";

export const FooterSection = () => {
  return (
    <Element
      id="footer_section_container"
      canvas
      is={Container}
      className="footer"
      padding="40px 20px"
      background="#0f172a"
      margin="0"
      borderRadius={0}
      width="100%"
      height="auto"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Image
        src="https://thegamingclub-lt.com/os-ui/static/lt-thegamingclub-msisdn-cmp-nid/files/8f190950d77d3eca4a95..svg"
        width="150px"
        height="auto"
        margin="0 0 20px 0"
        padding="0"
        borderRadius={0}
      />
      <Text
        text="© 2025 The Gaming Club. All rights reserved."
        fontSize={14}
        color="#9ca3af"
        fontWeight="normal"
        textAlign="center"
        margin="0 0 15px 0"
        padding="0"
      />
      <Element
        id="footer_links_container"
        canvas
        is={Container}
        background="transparent"
        padding="0"
        margin="0"
        borderRadius={0}
        width="auto"
        height="auto"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        gap="20px"
      >
        <Text
          text="Terms & Conditions"
          fontSize={14}
          color="#e5e7eb"
          fontWeight="normal"
          textAlign="center"
          margin="0"
          padding="0"
        />
        <Text
          text="Privacy Policy"
          fontSize={14}
          color="#e5e7eb"
          fontWeight="normal"
          textAlign="center"
          margin="0"
          padding="0"
        />
        <Text
          text="Contact Us"
          fontSize={14}
          color="#e5e7eb"
          fontWeight="normal"
          textAlign="center"
          margin="0"
          padding="0"
        />
        <Text
          text="Help Center"
          fontSize={14}
          color="#e5e7eb"
          fontWeight="normal"
          textAlign="center"
          margin="0"
          padding="0"
        />
      </Element>
    </Element>
  );
};
